<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@font-face {
  font-family: "iconfont"; /* Project id 2980072 */
  src: url("//at.alicdn.com/t/font_2980072_iorajuettbt.woff2?t=1642664607909")
      format("woff2"),
    url("//at.alicdn.com/t/font_2980072_iorajuettbt.woff?t=1642664607909")
      format("woff"),
    url("//at.alicdn.com/t/font_2980072_iorajuettbt.ttf?t=1642664607909")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 20px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.tableBox {
  th {
    padding: 0 !important;
    height: 30px;
    line-height: 30px;
  }
  td {
    padding: 0 !important;
    height: 50px;
    line-height: 50px;
  }
}
.tableBox02 {
  th {
    padding: 0 !important;
    height: 70px;
    line-height: 70px;
  }
  td {
    padding: 0 !important;
    height: 70px;
    line-height: 70px;
  }
}
body {
  background-color: #f8f9fa;
}
.el-card__body {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue